import { t, Trans } from "@lingui/macro";
import React from "react";
import cx from "classnames";
import { InfoCard } from "components/InfoCard";
import { ReactComponent as BalanceIcon } from "../icons/Balance.svg";
import { ReactComponent as RewardIcon } from "../icons/Reward.svg";

import { GeneralInfo, UserInfo } from "pages/Event/events/TradeToEarnEvent/types";
import parse from "parse-duration";
import { BigNumber } from "ethers";
import {
  // formatAmount,
  formatBigAmount,
} from "lib/formatAmount";
import { PALM_DECIMALS, TP_DECIMALS } from "lib/constants";
// import { useGetUsdAmountFromPalmAmount } from "lib/api/useTokenPrices";
import { getDailyReward } from "pages/Event/events/TradeToEarnEvent/utils/epocheDates";

type Props = React.ComponentProps<"div"> & {
  generalInfo: GeneralInfo;
  userInfo: UserInfo;
};

export const EpocheOverviewSection = React.memo((props: Props) => {
  const { generalInfo, userInfo } = props;

  const currentDate = new Date();
  const currentDay = Math.floor(parse(`${currentDate.valueOf()} ms`, "day") ?? 0);

  const dailyReward = React.useMemo<BigNumber>(() => {
    return getDailyReward({
      currentDay,
      generalInfo,
    });
  }, [currentDay, generalInfo]);

  // const getUsdAmountFromPalmAmount = useGetUsdAmountFromPalmAmount();

  const estimatedRewardsFOX = formatBigAmount(
    generalInfo.dailyTotalTp.gt(0)
      ? dailyReward.mul(userInfo.dailyUserTp).div(generalInfo.dailyTotalTp)
      : BigNumber.from(0),
    PALM_DECIMALS
  );

  // const estimatedRewardsUSD = formatAmount(
  //   getUsdAmountFromPalmAmount(dailyReward.mul(userInfo.dailyUserTp).div(generalInfo.dailyTotalTp)),
  //   { mantissa: 10 }
  // );
  // we need to add FOX price to API

  return (
    <div className={cx("@container/epoche-overview w-full md:w-1/3", props.className)}>
      <div className="flex flex-col justify-between h-full gap-6 md:gap-0">
        <InfoCard
          label={t`Your Balance`}
          data={`${formatBigAmount(userInfo.dailyUserTp, TP_DECIMALS)} TP`}
          icon={<BalanceIcon />}
          theme="event"
        />
        <InfoCard
          label={t`Your Estimated Rewards`}
          data={`${estimatedRewardsFOX} FOX`}
          icon={<RewardIcon />}
          // secondaryData={`~$${estimatedRewardsUSD}`}
          theme="event"
          tooltipText={
            <div className="w-[244px]">
              <Trans>
                Epoch Allocation refers to the distribution of FOX tokens as rewards to traders at the end of each
                epoch. The allocated FOX tokens are divided among traders based on their trading points earned during
                the epoch.
              </Trans>
            </div>
          }
        />

        <InfoCard
          label={t`Trading Point Supply`}
          data={`${formatBigAmount(generalInfo.dailyTotalTp, TP_DECIMALS)} TP`}
          iconText={"TP"}
          theme="event"
          tooltipText={t`Total Trading Point Supply in this epoch.`}
        />
      </div>
    </div>
  );
});
